import { CplaceSingleIconControlChange, CplaceSingleIconControlParameters } from '../../api/model/models';
import { ControlChangeHandler } from '../../controls';
import { mockControlIdentity, mockControlStateSharedData } from './controls.shared';
import { cplaceSingleIconControlAvailableIcons } from './cplace-single-icon-control-available-icons';

export const mockCplaceSingleIconControlControlParams: CplaceSingleIconControlParameters = {
  componentName: 'CplaceSingleIconControlComponent',
  value: cplaceSingleIconControlAvailableIcons[1],
  availableIcons: cplaceSingleIconControlAvailableIcons,
};

export const mockCplaceSingleIconControlState = {
  ...mockControlStateSharedData,
  identity: mockControlIdentity,
  controlParameters: mockCplaceSingleIconControlControlParams,
  displayIconLabels: true,
};

export const mockCplaceSingleIconControlChangeHandler: ControlChangeHandler<
  CplaceSingleIconControlChange,
  CplaceSingleIconControlParameters
> = (controlParameters, controlChange) => {
  return {
    ...controlParameters,
    value: controlParameters.availableIcons.find((icon) => icon.name === controlChange.value),
  };
};
